// extracted by css-extract-rspack-plugin
export default {"wrapper":"H8jlK","wrapper_full":"E6dSU","wrapperFull":"E6dSU","wrapper_embedded":"XsyMY","wrapperEmbedded":"XsyMY","desktop":"FVY3W"};